/**
 * Resolve transaction IDs created during an import session (time-window heuristic).
 */

import { supabase } from '../lib/supabase';

export async function fetchTransactionIdsForImportSession(
  importSessionId: string,
  accountId: string,
  importedCount: number,
  userId: string
): Promise<string[]> {
  const { data: session } = await supabase
    .from('import_sessions')
    .select('created_at')
    .eq('id', importSessionId)
    .single();

  if (!session || !session.created_at) return [];

  const sessionTime = new Date(session.created_at as string);
  const startTime = new Date(sessionTime.getTime() - 60000);
  const endTime = new Date(sessionTime.getTime() + 300000);

  const { data: transactions } = await supabase
    .from('transactions')
    .select('id')
    .eq('account_id', accountId)
    .eq('user_id', userId)
    .gte('created_at', startTime.toISOString())
    .lte('created_at', endTime.toISOString())
    .order('created_at', { ascending: false })
    .limit(importedCount);

  return transactions?.map(t => t.id) || [];
}
